import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.scss'],
  standalone: false
})
export class QuoteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
